import {
    Button,
    Container,
    Form,
    FormGroup,
    Segment,
    SegmentContent,
    SegmentHeader,
    TabNav,
    TabNavItem,
    Textarea,
} from '@/platform/ui';
import { ArrowLeftIcon } from '@heroicons/react/24/outline';
import { Link, useForm, usePage } from '@inertiajs/react';
import { useEffect, useMemo, useState } from 'react';
import Navigation from '../components/Navigation';
import { availableLanguages } from '../definitions';

const CreateOrUpdateView = () => {
    const [locale, setLocale] = useState('nl');
    const { question } = usePage().props;
    const { data, setData, post, patch, errors, processing } = useForm({});

    useEffect(() => {
        if (question?.id) {
            setData(question);
        }
    }, [question?.id]);

    const title = useMemo(
        () => (question?.id ? 'Wijzig vraag' : 'Nieuwe vraag'),
        [question]
    );

    const handleSubmit = () => {
        if (question?.id) {
            patch(`/questionnaires/questions/${question.id}`);

            return;
        }

        post('/questionnaires/questions');
    };

    return (
        <Container>
            <Navigation />

            <Form onSubmit={handleSubmit}>
                <Segment>
                    <SegmentHeader header={title}>
                        <Button as={Link} href='/questionnaires/questions'>
                            <ArrowLeftIcon className='size-5' />
                            Terug
                        </Button>
                    </SegmentHeader>
                    <SegmentContent>
                        <TabNav label='Talen'>
                            {availableLanguages.map(language => (
                                <TabNavItem
                                    key={language.key}
                                    active={language.key === locale}
                                    onClick={() => setLocale(language.key)}
                                >
                                    {language.text}
                                </TabNavItem>
                            ))}
                        </TabNav>
                        <FormGroup>
                            <Textarea
                                label='Vraag'
                                required
                                value={data?.question?.[locale] || ''}
                                onChange={event =>
                                    setData(
                                        `question.${locale}`,
                                        event.target.value
                                    )
                                }
                                error={
                                    errors?.[`question.${locale}`] ||
                                    errors?.question
                                }
                            />
                        </FormGroup>
                    </SegmentContent>
                </Segment>

                <Segment floating>
                    <SegmentContent right>
                        <Button
                            type='submit'
                            variant='primary'
                            loading={processing}
                        >
                            Opslaan
                        </Button>
                    </SegmentContent>
                </Segment>
            </Form>
        </Container>
    );
};

export default CreateOrUpdateView;
